import { WorkflowFormQuestion } from "../../../../utilsComponents/workflowParser"

/**
 * Derives a set of convenient boolean flags (`isTextFreeQuestion`,
 * `isSliderQuestion`, etc.) from the currently displayed question.
 * These flags are used by the UI components to determine which input
 * field should be rendered.
 * Centralizes the logic for reading `inputType` (and related properties
 * such as `choices` or `multiple`) in a single place, instead of
 * duplicating it across components.
 */
export function useQuestionTypeFlags(currentQuestion: WorkflowFormQuestion | null) {
    const inputType = (currentQuestion as any)?.inputType as
        | 'text'
        | 'number'
        | 'choice'
        | 'slider'
        | 'date'
        | 'sketch'
        | 'pj'
        | 'calculated'
        | 'message'
        | undefined

    return {
        inputType,
        isTextFreeQuestion: inputType === 'text',
        isNumberFreeQuestion: inputType === 'number',
        isSliderQuestion: inputType === 'slider',
        isDateQuestion: inputType === 'date',
        isSketchQuestion: inputType === 'sketch',
        isMessageQuestion: inputType === 'message',
        isChoiceQuestion: Boolean(currentQuestion?.choices?.length),
        isMultipleChoiceQuestion: Boolean((currentQuestion as any)?.multiple?.trigger),
    }
}
